// src/pages/PantallaBienvenida.jsx
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import fondo from '../assets/img_generales/fondo.png';
import logo from '../assets/img_generales/Logo.png';
import './PantallaBienvenida.css';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

/**
 * Pantalla de Splash: muestra logo + barra de progreso (fake) por ~4s
 * y redirige a `next` (querystring) o a /pantallatutorial por defecto.
 *
 * Ejemplo desde login:
 *   navigate('/bienvenida?next=/pantallatutorial');
 */
export default function SplashScreen() {
  const navigate = useNavigate();
  const query = useQuery();
  const next = query.get('next') || '/pantallatutorial'; 

  const [progress, setProgress] = useState(0);
  const rafRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => {
    // Animación suave (~4000ms)
    const totalMs = 4000;
    const step = (ts) => {
      if (!startRef.current) startRef.current = ts;
      const elapsed = ts - startRef.current;
      const pct = Math.min(100, Math.floor((elapsed / totalMs) * 100));
      setProgress(pct);
      if (pct < 100) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        // pequeño delay para mostrar 100%
        setTimeout(() => navigate(next, { replace: true }), 200);
      }
    };
    rafRef.current = requestAnimationFrame(step);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [navigate, next]);

  // Mensajes de carga fake
  const hints = useMemo(
    () => [
      'Cargando módulos del hospital…',
      'Preparando casos clínicos…',
      'Inicializando imágenes y recursos…',
      'Conectando con Servidor…',
      'Ajustando niveles…',
      'Listo para comenzar.',
    ],
    []
  );

  const hintIndex = Math.min(hints.length - 1, Math.floor(progress / (100 / hints.length)));
  const currentHint = hints[hintIndex];

  return (
    <div
      className="splash__wrap"
      style={{ backgroundImage: `url(${fondo})` }}
      role="status"
      aria-live="polite"
      aria-label={`Cargando Turno24 RX: ${progress}%`}
    >
      <div className="splash__card">
        <img src={logo} alt="Turno24 RX" className="splash__logo" />

        <div className="splash__bar">
          <div className="splash__barFill" style={{ width: `${progress}%` }} />
        </div>

        <div className="splash__percent">{progress}%</div>
        <div className="splash__hint">{currentHint}</div>

        <div className="splash__links">{/* ... */}</div>
      </div>
    </div>
  );
}
